module.exports = __webpack_public_path__ + "static/media/logo.b76cd425.svg";